import React from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip } from 'reactstrap'
import styles from './UnderlineSlatePlugin.scss'
import { TYPE, TRIGGER_KEY, hasUnderline, onClickButton } from './UnderlineSlatePluginContainer'

class UnderlineButton extends React.Component {
  constructor (props) {
    super(props)

    this.uid = Date.now()

    this.state = {
      tooltipOpen: false
    }
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  render () {
    const { state: editorState, noTooltip, onChange, style } = this.props
    const isActive = hasUnderline(editorState)

    const customStyle = {textDecoration: 'underline', fontFamily: 'serif'}

    return (
      <Button
        id={'UnderlineButton' + (noTooltip ? '' : this.uid)}
        style={{...style, ...customStyle}}
        onClick={e => onChange(onClickButton(e, editorState))}
        color={isActive ? 'primary' : 'secondary'}
        className={styles.UnderlineButton}
      > U
        {
          !noTooltip &&
          <Tooltip placement='top' isOpen={this.state.tooltipOpen} target={'UnderlineButton' + this.uid} toggle={this.toggle}>
            {TYPE} (CTL+{TRIGGER_KEY.toUpperCase()})
          </Tooltip>
        }
      </Button>
    )
  }
}

UnderlineButton.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  noTooltip: PropTypes.bool,
  style: PropTypes.object
}

export default UnderlineButton



// WEBPACK FOOTER //
// ./src/components/UnderlineSlatePlugin/UnderlineButton.js